import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimelineEvent } from '../review-utils';

@Component({
  selector: 'app-review-timeline-v2',
  imports: [CommonModule],
  templateUrl: './review-timeline-v2.component.html',
  styleUrl: './review-timeline-v2.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReviewTimelineV2Component {
  @Input() events: TimelineEvent[] = [];

  trackByIndex(i: number): number {
    return i;
  }
}
